// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './routes'
// import Vuetify from 'vuetify/lib'
import vuetify from '@/plugins/vuetify'
import AppLayout from './components/Layout.vue'
import AppHome from './components/Home.vue'
import AppSignin from './components/Auth/Signin.vue'
import AppRegister from './components/Auth/Register.vue'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import { store } from './store/index'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.config.productionTip = false
Vue.use(Viewer)
Vue.component('app-layout', AppLayout)
Vue.component('app-home', AppHome)
Vue.component('app-signin', AppSignin)
Vue.component('app-register', AppRegister)

/* eslint-disable no-new */
export default new Vue({
  vuetify,
  router,
  store,
  components: { App },
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js